import { Check, LoaderCircle } from 'lucide-react'
import type { LanguagePack } from '../i18n/packs'

export type Step = 1 | 2 | 3 | 4

export function Processing({
  p,
  step,
  progress,
  downloading,
  onCancel
}: {
  p: LanguagePack
  step: Step
  /** 0-1 progress of the current step, when known */
  progress: number | null
  downloading: boolean
  onCancel: () => void
}) {
  const steps = [p.stepCheck, p.stepRead, p.stepExtract, p.stepExplain]
  return (
    <section className="processing-view" aria-live="polite">
      <ol className="step-list">
        {steps.map((label, index) => {
          const n = index + 1
          const state = n < step ? 'done' : n === step ? 'current' : 'pending'
          return (
            <li key={label} className={`step-item ${state}`}>
              <span className="step-icon" aria-hidden="true">
                {state === 'done' ? <Check size={20} /> : state === 'current' ? <LoaderCircle className="spin" size={20} /> : n}
              </span>
              <div className="step-body">
                <span>{label}</span>
                {state === 'current' && progress !== null && (
                  <div className="progress-bar-wrap" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)}>
                    <div className="progress-bar-fill" style={{ width: `${Math.max(4, Math.round(progress * 100))}%` }} />
                  </div>
                )}
                {state === 'current' && downloading && <small>{p.firstTimeNote}</small>}
              </div>
            </li>
          )
        })}
      </ol>
      <button className="text-button cancel-button" onClick={onCancel}>
        {p.cancel}
      </button>
    </section>
  )
}
